module.exports = __webpack_public_path__ + "static/media/icon_encrypted_drop.cc3069ed.svg";